import type { IconDefinition } from '../index.tsx';

export const iconArrowDownCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowDownCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12 8H9V3H7V8H4V9L8 13L12 9V8Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
